import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from '../rootReducer';
import { OPEN_BID_LIMIT_EXCEEDED_MODAL } from './actions';

export type State = {
    catalogId: number;
};

export const DEFAULT_STATE: State = {
    catalogId: 0,
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}): State {
    switch (action.type) {
        case OPEN_BID_LIMIT_EXCEEDED_MODAL:
            return {
                ...state,
                catalogId: action.payload,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.bidLimitExceeded;

export const getBidLimitExceededCatalogId = createSelector(stateSelector, (state) => state.catalogId);
